import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { ViewStatFields } from '../models/ContentTypes';
import { IViewInfo } from '../models/IViewInfo';
import { Module } from '../Module';
import { GetDetailedRecentsRequest } from '../ServerApi/requests/GetDetailedRecentsRequest';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { FetcherFactory } from '../services/FetcherFactory';
import { ResourceQuery } from './ResourceQuery';

export class Recents {
  public static $inject = ['FetcherFactory'];

  private getRecentViews: IListFetcher<IViewInfo>;

  constructor(FetcherFactory: FetcherFactory) {
    this.getRecentViews = FetcherFactory.getServerResourceFetcher(GetDetailedRecentsRequest, ServerApiMapper.recentViews);
  }

  public allViews(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IViewInfo> {
    return new ResourceQuery(this.getRecentViews)
      .withExtraParams({'viewStatFields': ViewStatFields, 'objectTypes': ['VIEW']})
      .withFilters(additionalFilterClauses);
  }
}

Module.instance().service('Recents', Recents);
